import React, { useEffect, useImperativeHandle, useState } from "react";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import CheckboxesTags from "../CheckboxFilter/CheckboxesTags";
import { connect } from "react-redux";
import DateAndTimeFilter from "./DateAndTimeFilter";
import { set } from "date-fns";
import { forwardRef } from "react";

const FilterData = forwardRef(
  ({
    FilterCategories,
    filterHandler,
    hideDateFilter,
    preSelectedFilters,
    dynamicFilterMethod,
    dynamicArray,
    resetRef,
  }) => {
    const [selectedValues, setSelectedValues] = useState([]);
    const [chip, setChips] = useState([]);
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);

    useImperativeHandle(resetRef, () => ({
      refReset,
    }));

    //it will call from parent component for create shipping order & create purchase order page
    const refReset = () => {
      setChips([]);
      setSelectedValues([]);
      setDateFrom(null);
      setDateTo(null);
    };

    const handleDateTime = (dateFrom, dateTo) => {
      if (dateFrom && dateTo) {
        setDateFrom(dateFrom);
        setDateTo(dateTo);
        let temp = selectedValues.filter((item) => item.type !== "Date");
        setSelectedValues([
          // ...selectedValues,
          ...temp,
          {
            type: "Date",
            Uid: "Date",
            id: 1,
            from: dateFrom,
            to: dateTo,
            name: `${dateFrom.getDate()}-${
              dateFrom.getMonth() + 1
            }-${dateFrom.getFullYear()}
        To
        ${dateTo.getDate()}-${dateTo.getMonth() + 1}-${dateTo.getFullYear()}
        `,
          },
        ]);
      }
    };

    const handleChange = (_event, valueObject, category, multi) => {
      if (multi) {
        const option = valueObject[0];
        const uid = option.label
          ? `${category + option.id + option.label}`
          : `${category + option.id}`;
        const isAlreadySelected = selectedValues.some(
          (item) => item.Uid === uid
        );
        if (!isAlreadySelected) {
          // as warehouse and store can have same id so we need to use label field to create customise uId
          setSelectedValues([
            ...selectedValues,
            { ...option, Uid: uid, type: category },
          ]);
        } else {
          setSelectedValues((value) =>
            value.filter((data) => data.Uid !== uid)
          );
        }
      } else {
        //here multi = false filter type value get selected
        let temp = selectedValues.filter((item) => item.type !== category);
        setSelectedValues([
          ...temp,
          {
            ...valueObject[0],
            Uid: `${category + valueObject[0].id}`,
            type: category,
          },
        ]);
        if (dynamicArray.includes(category)) {
          dynamicFilterMethod(valueObject[0], category);
        }
      }
    };

    // const preSelectedHandler = () => {
    //   setSelectedValues(preSelectedFilters);
    // };

    const checkBoxChangeHandler = (ev, option) => {
      if (!ev.target.checked) {
        setSelectedValues((value) =>
          value.filter((chip) => chip.Uid !== option.Uid)
        );
      }
    };

    useEffect(() => {
      if (preSelectedFilters) {
        setSelectedValues(preSelectedFilters);
        setChips(preSelectedFilters);
        filterHandler(preSelectedFilters);
      }
    }, []);

    const submitHandler = (e) => {
      setChips(selectedValues);
      filterHandler(selectedValues);
    };

    const resetHandler = (e) => {
      setChips([]);
      setSelectedValues([]);
      setDateFrom(null);
      setDateTo(null);
      filterHandler([]);
    };
    const handleDelete = (ChipData) => {
      setChips((chips) => chips.filter((chip) => chip.Uid !== ChipData.Uid));
      setSelectedValues((value) =>
        value.filter((chip) => chip.Uid !== ChipData.Uid)
      );
      if (ChipData.type === "Date") {
        setDateFrom(null);
        setDateTo(null);
      }

      filterHandler(selectedValues.filter((chip) => chip.Uid !== ChipData.Uid));
    };

    // useEffect(() => {
    //   console.log("chip", chip);
    //   filterHandler(chip);
    // }, [chip]);

    return (
      <div className="filter_content">
        <div className="filter-sub-box">
          <div className="dropdown">
            {!hideDateFilter ? (
              <DateAndTimeFilter
                dateFrom={dateFrom}
                dateTo={dateTo}
                handleDateTime={handleDateTime}
              />
            ) : (
              ""
            )}
            {FilterCategories?.map((FilterCategory) => {
              return FilterCategory.type === "Date" ? (
                ""
              ) : (
                <CheckboxesTags
                  multi={FilterCategory.multi}
                  key={FilterCategory.type}
                  handleChange={handleChange}
                  FilterCategory={FilterCategory}
                  selectedValues={selectedValues}
                  checkBoxChangeHandler={checkBoxChangeHandler}
                />
              );
            })}
          </div>

          <div className="filter-btns">
            <div
              style={{ marginRight: "4px" }}
              className="btn-1 cr-pointer"
              onClick={resetHandler}
            >
              &nbsp; Reset
            </div>

            <button
              className={`btn-2 cr-pointer btn-2-color ${
                selectedValues.length ? "" : "pointer-events--disabled"
              }`}
              onClick={submitHandler}
            >
              Apply Filter
            </button>
          </div>
        </div>
        <Stack direction="row" spacing={1}>
          {chip.map(
            (val, index) => {
              return index < 8 ? (
                <Chip
                  key={val.Uid}
                  label={val.name}
                  variant="outlined"
                  className="btn-2-color"
                  onDelete={(e) => handleDelete(val)}
                />
              ) : (
                ""
              );
            }

            // ))
          )}
        </Stack>
      </div>
    );
  }
);
// /Retrieve redux storage.
const mapStateToProps = (state) => ({
  franchiseList: state.franchiseListReducer.list,
});

//Dispatch actions to redux.
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FilterData);
